import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _CloseRoundDuotone(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 12, r: 9, fill: "#7e869e", fillOpacity: 0.25 }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.2, d: "m16 8-8 8M8 8l8 8" })] }) });
}
const CloseRoundDuotone = forwardRef(_CloseRoundDuotone);
export { CloseRoundDuotone };
